import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingFailedHintComponent, PmButtonComponent } from '@libs/ui';
import { LucidePlus } from '@lucide/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisContentComponent } from 'demand-forecasting/analysis/components/analysis-content/analysis-content.component';
import { CreateAnalysisConfigurationDialogComponent } from 'demand-forecasting/analysis/components/configuration/create-analysis-configuration-dialog.component';
import { AnalysisStateService } from 'demand-forecasting/analysis/services/analysis-state.service';

@Component({
  selector: 'pm-analysis-page',
  templateUrl: './analysis-page.component.html',
  host: { class: 'flex flex-col h-full' },
  imports: [
    TranslateModule,
    MatDividerModule,
    MatProgressSpinner,
    LoadingFailedHintComponent,
    PmButtonComponent,
    AnalysisContentComponent,
  ],
})
export class AnalysisPageComponent {
  private readonly dialog = inject(MatDialog);
  protected readonly analysisStateService = inject(AnalysisStateService);

  protected readonly plusIcon = LucidePlus;

  protected handleCreateErrorConfiguration() {
    this.dialog.open(CreateAnalysisConfigurationDialogComponent, {
      width: '640px',
      height: '754px',
    });
  }
}
